/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY Backend
 * PEXIFY operating system backend — privately governed commerce ecosystem. M3 başlangıcı: FastAPI shell. Faz 1-6 schema RATIFIED; per-component CRUD + RBAC + audit emit + engines (M-AUDIT / M-WALLET / M-POLICY / M-NOTIF) coming.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CommandAdminProblemReport401,
  CommandAdminProblemReport403,
  CommandAdminProblemReport404,
  CommandAdminProblemReport405,
  CommandAdminProblemReport409,
  CommandAdminProblemReport413,
  CommandAdminProblemReport422,
  CommandAdminProblemReport429,
  CommandAdminProblemReport500,
  CommandAdminProblemReport503,
  ConfirmProblemReport401,
  ConfirmProblemReport403,
  ConfirmProblemReport404,
  ConfirmProblemReport405,
  ConfirmProblemReport409,
  ConfirmProblemReport413,
  ConfirmProblemReport422,
  ConfirmProblemReport429,
  ConfirmProblemReport500,
  ConfirmProblemReport503,
  ConfirmProblemReportAttachment401,
  ConfirmProblemReportAttachment403,
  ConfirmProblemReportAttachment404,
  ConfirmProblemReportAttachment405,
  ConfirmProblemReportAttachment409,
  ConfirmProblemReportAttachment413,
  ConfirmProblemReportAttachment422,
  ConfirmProblemReportAttachment429,
  ConfirmProblemReportAttachment500,
  ConfirmProblemReportAttachment503,
  CreateProblemReport401,
  CreateProblemReport403,
  CreateProblemReport404,
  CreateProblemReport405,
  CreateProblemReport409,
  CreateProblemReport413,
  CreateProblemReport422,
  CreateProblemReport429,
  CreateProblemReport500,
  CreateProblemReport503,
  DownloadAdminProblemReportAttachment401,
  DownloadAdminProblemReportAttachment403,
  DownloadAdminProblemReportAttachment404,
  DownloadAdminProblemReportAttachment405,
  DownloadAdminProblemReportAttachment409,
  DownloadAdminProblemReportAttachment413,
  DownloadAdminProblemReportAttachment422,
  DownloadAdminProblemReportAttachment429,
  DownloadAdminProblemReportAttachment500,
  DownloadAdminProblemReportAttachment503,
  DownloadAdminProblemReportAttachmentParams,
  DownloadOwnProblemReportAttachment401,
  DownloadOwnProblemReportAttachment403,
  DownloadOwnProblemReportAttachment404,
  DownloadOwnProblemReportAttachment405,
  DownloadOwnProblemReportAttachment409,
  DownloadOwnProblemReportAttachment413,
  DownloadOwnProblemReportAttachment422,
  DownloadOwnProblemReportAttachment429,
  DownloadOwnProblemReportAttachment500,
  DownloadOwnProblemReportAttachment503,
  DownloadOwnProblemReportAttachmentParams,
  GetAdminProblemReport401,
  GetAdminProblemReport403,
  GetAdminProblemReport404,
  GetAdminProblemReport405,
  GetAdminProblemReport409,
  GetAdminProblemReport413,
  GetAdminProblemReport422,
  GetAdminProblemReport429,
  GetAdminProblemReport500,
  GetAdminProblemReport503,
  GetOwnProblemReport401,
  GetOwnProblemReport403,
  GetOwnProblemReport404,
  GetOwnProblemReport405,
  GetOwnProblemReport409,
  GetOwnProblemReport413,
  GetOwnProblemReport422,
  GetOwnProblemReport429,
  GetOwnProblemReport500,
  GetOwnProblemReport503,
  GetOwnProblemReportNotificationTarget401,
  GetOwnProblemReportNotificationTarget403,
  GetOwnProblemReportNotificationTarget404,
  GetOwnProblemReportNotificationTarget405,
  GetOwnProblemReportNotificationTarget409,
  GetOwnProblemReportNotificationTarget413,
  GetOwnProblemReportNotificationTarget422,
  GetOwnProblemReportNotificationTarget429,
  GetOwnProblemReportNotificationTarget500,
  GetOwnProblemReportNotificationTarget503,
  GetProblemReportCapabilities401,
  GetProblemReportCapabilities403,
  GetProblemReportCapabilities404,
  GetProblemReportCapabilities405,
  GetProblemReportCapabilities409,
  GetProblemReportCapabilities413,
  GetProblemReportCapabilities422,
  GetProblemReportCapabilities429,
  GetProblemReportCapabilities500,
  GetProblemReportCapabilities503,
  ListAdminProblemReports401,
  ListAdminProblemReports403,
  ListAdminProblemReports404,
  ListAdminProblemReports405,
  ListAdminProblemReports409,
  ListAdminProblemReports413,
  ListAdminProblemReports422,
  ListAdminProblemReports429,
  ListAdminProblemReports500,
  ListAdminProblemReports503,
  ListAdminProblemReportsParams,
  ListOwnProblemReports401,
  ListOwnProblemReports403,
  ListOwnProblemReports404,
  ListOwnProblemReports405,
  ListOwnProblemReports409,
  ListOwnProblemReports413,
  ListOwnProblemReports422,
  ListOwnProblemReports429,
  ListOwnProblemReports500,
  ListOwnProblemReports503,
  ListOwnProblemReportsParams,
  ListProblemReportAssignees401,
  ListProblemReportAssignees403,
  ListProblemReportAssignees404,
  ListProblemReportAssignees405,
  ListProblemReportAssignees409,
  ListProblemReportAssignees413,
  ListProblemReportAssignees422,
  ListProblemReportAssignees429,
  ListProblemReportAssignees500,
  ListProblemReportAssignees503,
  ListProblemReportAssigneesParams,
  ListProblemReportNotifications401,
  ListProblemReportNotifications403,
  ListProblemReportNotifications404,
  ListProblemReportNotifications405,
  ListProblemReportNotifications409,
  ListProblemReportNotifications413,
  ListProblemReportNotifications422,
  ListProblemReportNotifications429,
  ListProblemReportNotifications500,
  ListProblemReportNotifications503,
  ListProblemReportNotificationsParams,
  ProblemReportAdminPage,
  ProblemReportAdminRead,
  ProblemReportAssigneePage,
  ProblemReportAttachmentRead,
  ProblemReportCapabilities,
  ProblemReportCommand,
  ProblemReportCommandReceipt,
  ProblemReportConfirmation,
  ProblemReportCreate,
  ProblemReportDownloadGrant,
  ProblemReportNotificationPage,
  ProblemReportNotificationTarget,
  ProblemReportPage,
  ProblemReportRead,
  ProblemReportUploadConfirm,
  ProblemReportUploadGrant,
  ProblemReportUploadRequest,
  ReserveProblemReportAttachment401,
  ReserveProblemReportAttachment403,
  ReserveProblemReportAttachment404,
  ReserveProblemReportAttachment405,
  ReserveProblemReportAttachment409,
  ReserveProblemReportAttachment413,
  ReserveProblemReportAttachment422,
  ReserveProblemReportAttachment429,
  ReserveProblemReportAttachment500,
  ReserveProblemReportAttachment503
} from '../model';

import { orvalClient } from '../../orval-client';




export type listAdminProblemReportsResponse200 = {
  data: ProblemReportAdminPage
  status: 200
}

export type listAdminProblemReportsResponse401 = {
  data: ListAdminProblemReports401
  status: 401
}

export type listAdminProblemReportsResponse403 = {
  data: ListAdminProblemReports403
  status: 403
}

export type listAdminProblemReportsResponse404 = {
  data: ListAdminProblemReports404
  status: 404
}

export type listAdminProblemReportsResponse405 = {
  data: ListAdminProblemReports405
  status: 405
}

export type listAdminProblemReportsResponse409 = {
  data: ListAdminProblemReports409
  status: 409
}

export type listAdminProblemReportsResponse413 = {
  data: ListAdminProblemReports413
  status: 413
}

export type listAdminProblemReportsResponse422 = {
  data: ListAdminProblemReports422
  status: 422
}

export type listAdminProblemReportsResponse429 = {
  data: ListAdminProblemReports429
  status: 429
}

export type listAdminProblemReportsResponse500 = {
  data: ListAdminProblemReports500
  status: 500
}

export type listAdminProblemReportsResponse503 = {
  data: ListAdminProblemReports503
  status: 503
}

export type listAdminProblemReportsResponseSuccess = (listAdminProblemReportsResponse200) & {
  headers: Headers;
};
export type listAdminProblemReportsResponseError = (listAdminProblemReportsResponse401 | listAdminProblemReportsResponse403 | listAdminProblemReportsResponse404 | listAdminProblemReportsResponse405 | listAdminProblemReportsResponse409 | listAdminProblemReportsResponse413 | listAdminProblemReportsResponse422 | listAdminProblemReportsResponse429 | listAdminProblemReportsResponse500 | listAdminProblemReportsResponse503) & {
  headers: Headers;
};

export type listAdminProblemReportsResponse = (listAdminProblemReportsResponseSuccess | listAdminProblemReportsResponseError)

export const getListAdminProblemReportsUrl = (params?: ListAdminProblemReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/problem-reports?${stringifiedParams}` : `/api/v1/admin/problem-reports`
}

/**
 * @summary List Admin
 */
export const listAdminProblemReports = async (params?: ListAdminProblemReportsParams, options?: RequestInit): Promise<listAdminProblemReportsResponse> => {

  return orvalClient<listAdminProblemReportsResponse>(getListAdminProblemReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminProblemReportsQueryKey = (params?: ListAdminProblemReportsParams,) => {
    return [
    `/api/v1/admin/problem-reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminProblemReportsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = ListAdminProblemReports401 | ListAdminProblemReports403 | ListAdminProblemReports404 | ListAdminProblemReports405 | ListAdminProblemReports409 | ListAdminProblemReports413 | ListAdminProblemReports422 | ListAdminProblemReports429 | ListAdminProblemReports500 | ListAdminProblemReports503>(params?: ListAdminProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminProblemReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminProblemReports>>> = ({ signal }) => listAdminProblemReports(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminProblemReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminProblemReports>>>
export type ListAdminProblemReportsQueryError = ListAdminProblemReports401 | ListAdminProblemReports403 | ListAdminProblemReports404 | ListAdminProblemReports405 | ListAdminProblemReports409 | ListAdminProblemReports413 | ListAdminProblemReports422 | ListAdminProblemReports429 | ListAdminProblemReports500 | ListAdminProblemReports503


export function useListAdminProblemReports<TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = ListAdminProblemReports401 | ListAdminProblemReports403 | ListAdminProblemReports404 | ListAdminProblemReports405 | ListAdminProblemReports409 | ListAdminProblemReports413 | ListAdminProblemReports422 | ListAdminProblemReports429 | ListAdminProblemReports500 | ListAdminProblemReports503>(
 params: undefined |  ListAdminProblemReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminProblemReports>>,
          TError,
          Awaited<ReturnType<typeof listAdminProblemReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminProblemReports<TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = ListAdminProblemReports401 | ListAdminProblemReports403 | ListAdminProblemReports404 | ListAdminProblemReports405 | ListAdminProblemReports409 | ListAdminProblemReports413 | ListAdminProblemReports422 | ListAdminProblemReports429 | ListAdminProblemReports500 | ListAdminProblemReports503>(
 params?: ListAdminProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminProblemReports>>,
          TError,
          Awaited<ReturnType<typeof listAdminProblemReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminProblemReports<TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = ListAdminProblemReports401 | ListAdminProblemReports403 | ListAdminProblemReports404 | ListAdminProblemReports405 | ListAdminProblemReports409 | ListAdminProblemReports413 | ListAdminProblemReports422 | ListAdminProblemReports429 | ListAdminProblemReports500 | ListAdminProblemReports503>(
 params?: ListAdminProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Admin
 */

export function useListAdminProblemReports<TData = Awaited<ReturnType<typeof listAdminProblemReports>>, TError = ListAdminProblemReports401 | ListAdminProblemReports403 | ListAdminProblemReports404 | ListAdminProblemReports405 | ListAdminProblemReports409 | ListAdminProblemReports413 | ListAdminProblemReports422 | ListAdminProblemReports429 | ListAdminProblemReports500 | ListAdminProblemReports503>(
 params?: ListAdminProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminProblemReports>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminProblemReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listProblemReportAssigneesResponse200 = {
  data: ProblemReportAssigneePage
  status: 200
}

export type listProblemReportAssigneesResponse401 = {
  data: ListProblemReportAssignees401
  status: 401
}

export type listProblemReportAssigneesResponse403 = {
  data: ListProblemReportAssignees403
  status: 403
}

export type listProblemReportAssigneesResponse404 = {
  data: ListProblemReportAssignees404
  status: 404
}

export type listProblemReportAssigneesResponse405 = {
  data: ListProblemReportAssignees405
  status: 405
}

export type listProblemReportAssigneesResponse409 = {
  data: ListProblemReportAssignees409
  status: 409
}

export type listProblemReportAssigneesResponse413 = {
  data: ListProblemReportAssignees413
  status: 413
}

export type listProblemReportAssigneesResponse422 = {
  data: ListProblemReportAssignees422
  status: 422
}

export type listProblemReportAssigneesResponse429 = {
  data: ListProblemReportAssignees429
  status: 429
}

export type listProblemReportAssigneesResponse500 = {
  data: ListProblemReportAssignees500
  status: 500
}

export type listProblemReportAssigneesResponse503 = {
  data: ListProblemReportAssignees503
  status: 503
}

export type listProblemReportAssigneesResponseSuccess = (listProblemReportAssigneesResponse200) & {
  headers: Headers;
};
export type listProblemReportAssigneesResponseError = (listProblemReportAssigneesResponse401 | listProblemReportAssigneesResponse403 | listProblemReportAssigneesResponse404 | listProblemReportAssigneesResponse405 | listProblemReportAssigneesResponse409 | listProblemReportAssigneesResponse413 | listProblemReportAssigneesResponse422 | listProblemReportAssigneesResponse429 | listProblemReportAssigneesResponse500 | listProblemReportAssigneesResponse503) & {
  headers: Headers;
};

export type listProblemReportAssigneesResponse = (listProblemReportAssigneesResponseSuccess | listProblemReportAssigneesResponseError)

export const getListProblemReportAssigneesUrl = (params?: ListProblemReportAssigneesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/problem-reports/assignees?${stringifiedParams}` : `/api/v1/admin/problem-reports/assignees`
}

/**
 * @summary Assignees
 */
export const listProblemReportAssignees = async (params?: ListProblemReportAssigneesParams, options?: RequestInit): Promise<listProblemReportAssigneesResponse> => {

  return orvalClient<listProblemReportAssigneesResponse>(getListProblemReportAssigneesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProblemReportAssigneesQueryKey = (params?: ListProblemReportAssigneesParams,) => {
    return [
    `/api/v1/admin/problem-reports/assignees`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProblemReportAssigneesQueryOptions = <TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = ListProblemReportAssignees401 | ListProblemReportAssignees403 | ListProblemReportAssignees404 | ListProblemReportAssignees405 | ListProblemReportAssignees409 | ListProblemReportAssignees413 | ListProblemReportAssignees422 | ListProblemReportAssignees429 | ListProblemReportAssignees500 | ListProblemReportAssignees503>(params?: ListProblemReportAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProblemReportAssigneesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProblemReportAssignees>>> = ({ signal }) => listProblemReportAssignees(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProblemReportAssigneesQueryResult = NonNullable<Awaited<ReturnType<typeof listProblemReportAssignees>>>
export type ListProblemReportAssigneesQueryError = ListProblemReportAssignees401 | ListProblemReportAssignees403 | ListProblemReportAssignees404 | ListProblemReportAssignees405 | ListProblemReportAssignees409 | ListProblemReportAssignees413 | ListProblemReportAssignees422 | ListProblemReportAssignees429 | ListProblemReportAssignees500 | ListProblemReportAssignees503


export function useListProblemReportAssignees<TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = ListProblemReportAssignees401 | ListProblemReportAssignees403 | ListProblemReportAssignees404 | ListProblemReportAssignees405 | ListProblemReportAssignees409 | ListProblemReportAssignees413 | ListProblemReportAssignees422 | ListProblemReportAssignees429 | ListProblemReportAssignees500 | ListProblemReportAssignees503>(
 params: undefined |  ListProblemReportAssigneesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProblemReportAssignees>>,
          TError,
          Awaited<ReturnType<typeof listProblemReportAssignees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProblemReportAssignees<TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = ListProblemReportAssignees401 | ListProblemReportAssignees403 | ListProblemReportAssignees404 | ListProblemReportAssignees405 | ListProblemReportAssignees409 | ListProblemReportAssignees413 | ListProblemReportAssignees422 | ListProblemReportAssignees429 | ListProblemReportAssignees500 | ListProblemReportAssignees503>(
 params?: ListProblemReportAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProblemReportAssignees>>,
          TError,
          Awaited<ReturnType<typeof listProblemReportAssignees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProblemReportAssignees<TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = ListProblemReportAssignees401 | ListProblemReportAssignees403 | ListProblemReportAssignees404 | ListProblemReportAssignees405 | ListProblemReportAssignees409 | ListProblemReportAssignees413 | ListProblemReportAssignees422 | ListProblemReportAssignees429 | ListProblemReportAssignees500 | ListProblemReportAssignees503>(
 params?: ListProblemReportAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Assignees
 */

export function useListProblemReportAssignees<TData = Awaited<ReturnType<typeof listProblemReportAssignees>>, TError = ListProblemReportAssignees401 | ListProblemReportAssignees403 | ListProblemReportAssignees404 | ListProblemReportAssignees405 | ListProblemReportAssignees409 | ListProblemReportAssignees413 | ListProblemReportAssignees422 | ListProblemReportAssignees429 | ListProblemReportAssignees500 | ListProblemReportAssignees503>(
 params?: ListProblemReportAssigneesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportAssignees>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProblemReportAssigneesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getAdminProblemReportResponse200 = {
  data: ProblemReportAdminRead
  status: 200
}

export type getAdminProblemReportResponse401 = {
  data: GetAdminProblemReport401
  status: 401
}

export type getAdminProblemReportResponse403 = {
  data: GetAdminProblemReport403
  status: 403
}

export type getAdminProblemReportResponse404 = {
  data: GetAdminProblemReport404
  status: 404
}

export type getAdminProblemReportResponse405 = {
  data: GetAdminProblemReport405
  status: 405
}

export type getAdminProblemReportResponse409 = {
  data: GetAdminProblemReport409
  status: 409
}

export type getAdminProblemReportResponse413 = {
  data: GetAdminProblemReport413
  status: 413
}

export type getAdminProblemReportResponse422 = {
  data: GetAdminProblemReport422
  status: 422
}

export type getAdminProblemReportResponse429 = {
  data: GetAdminProblemReport429
  status: 429
}

export type getAdminProblemReportResponse500 = {
  data: GetAdminProblemReport500
  status: 500
}

export type getAdminProblemReportResponse503 = {
  data: GetAdminProblemReport503
  status: 503
}

export type getAdminProblemReportResponseSuccess = (getAdminProblemReportResponse200) & {
  headers: Headers;
};
export type getAdminProblemReportResponseError = (getAdminProblemReportResponse401 | getAdminProblemReportResponse403 | getAdminProblemReportResponse404 | getAdminProblemReportResponse405 | getAdminProblemReportResponse409 | getAdminProblemReportResponse413 | getAdminProblemReportResponse422 | getAdminProblemReportResponse429 | getAdminProblemReportResponse500 | getAdminProblemReportResponse503) & {
  headers: Headers;
};

export type getAdminProblemReportResponse = (getAdminProblemReportResponseSuccess | getAdminProblemReportResponseError)

export const getGetAdminProblemReportUrl = (id: string,) => {




  return `/api/v1/admin/problem-reports/${id}`
}

/**
 * @summary Detail
 */
export const getAdminProblemReport = async (id: string, options?: RequestInit): Promise<getAdminProblemReportResponse> => {

  return orvalClient<getAdminProblemReportResponse>(getGetAdminProblemReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminProblemReportQueryKey = (id: string,) => {
    return [
    `/api/v1/admin/problem-reports/${id}`
    ] as const;
    }


export const getGetAdminProblemReportQueryOptions = <TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = GetAdminProblemReport401 | GetAdminProblemReport403 | GetAdminProblemReport404 | GetAdminProblemReport405 | GetAdminProblemReport409 | GetAdminProblemReport413 | GetAdminProblemReport422 | GetAdminProblemReport429 | GetAdminProblemReport500 | GetAdminProblemReport503>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminProblemReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminProblemReport>>> = ({ signal }) => getAdminProblemReport(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminProblemReportQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminProblemReport>>>
export type GetAdminProblemReportQueryError = GetAdminProblemReport401 | GetAdminProblemReport403 | GetAdminProblemReport404 | GetAdminProblemReport405 | GetAdminProblemReport409 | GetAdminProblemReport413 | GetAdminProblemReport422 | GetAdminProblemReport429 | GetAdminProblemReport500 | GetAdminProblemReport503


export function useGetAdminProblemReport<TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = GetAdminProblemReport401 | GetAdminProblemReport403 | GetAdminProblemReport404 | GetAdminProblemReport405 | GetAdminProblemReport409 | GetAdminProblemReport413 | GetAdminProblemReport422 | GetAdminProblemReport429 | GetAdminProblemReport500 | GetAdminProblemReport503>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProblemReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminProblemReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminProblemReport<TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = GetAdminProblemReport401 | GetAdminProblemReport403 | GetAdminProblemReport404 | GetAdminProblemReport405 | GetAdminProblemReport409 | GetAdminProblemReport413 | GetAdminProblemReport422 | GetAdminProblemReport429 | GetAdminProblemReport500 | GetAdminProblemReport503>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminProblemReport>>,
          TError,
          Awaited<ReturnType<typeof getAdminProblemReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminProblemReport<TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = GetAdminProblemReport401 | GetAdminProblemReport403 | GetAdminProblemReport404 | GetAdminProblemReport405 | GetAdminProblemReport409 | GetAdminProblemReport413 | GetAdminProblemReport422 | GetAdminProblemReport429 | GetAdminProblemReport500 | GetAdminProblemReport503>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detail
 */

export function useGetAdminProblemReport<TData = Awaited<ReturnType<typeof getAdminProblemReport>>, TError = GetAdminProblemReport401 | GetAdminProblemReport403 | GetAdminProblemReport404 | GetAdminProblemReport405 | GetAdminProblemReport409 | GetAdminProblemReport413 | GetAdminProblemReport422 | GetAdminProblemReport429 | GetAdminProblemReport500 | GetAdminProblemReport503>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminProblemReport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminProblemReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type downloadAdminProblemReportAttachmentResponse200 = {
  data: ProblemReportDownloadGrant
  status: 200
}

export type downloadAdminProblemReportAttachmentResponse401 = {
  data: DownloadAdminProblemReportAttachment401
  status: 401
}

export type downloadAdminProblemReportAttachmentResponse403 = {
  data: DownloadAdminProblemReportAttachment403
  status: 403
}

export type downloadAdminProblemReportAttachmentResponse404 = {
  data: DownloadAdminProblemReportAttachment404
  status: 404
}

export type downloadAdminProblemReportAttachmentResponse405 = {
  data: DownloadAdminProblemReportAttachment405
  status: 405
}

export type downloadAdminProblemReportAttachmentResponse409 = {
  data: DownloadAdminProblemReportAttachment409
  status: 409
}

export type downloadAdminProblemReportAttachmentResponse413 = {
  data: DownloadAdminProblemReportAttachment413
  status: 413
}

export type downloadAdminProblemReportAttachmentResponse422 = {
  data: DownloadAdminProblemReportAttachment422
  status: 422
}

export type downloadAdminProblemReportAttachmentResponse429 = {
  data: DownloadAdminProblemReportAttachment429
  status: 429
}

export type downloadAdminProblemReportAttachmentResponse500 = {
  data: DownloadAdminProblemReportAttachment500
  status: 500
}

export type downloadAdminProblemReportAttachmentResponse503 = {
  data: DownloadAdminProblemReportAttachment503
  status: 503
}

export type downloadAdminProblemReportAttachmentResponseSuccess = (downloadAdminProblemReportAttachmentResponse200) & {
  headers: Headers;
};
export type downloadAdminProblemReportAttachmentResponseError = (downloadAdminProblemReportAttachmentResponse401 | downloadAdminProblemReportAttachmentResponse403 | downloadAdminProblemReportAttachmentResponse404 | downloadAdminProblemReportAttachmentResponse405 | downloadAdminProblemReportAttachmentResponse409 | downloadAdminProblemReportAttachmentResponse413 | downloadAdminProblemReportAttachmentResponse422 | downloadAdminProblemReportAttachmentResponse429 | downloadAdminProblemReportAttachmentResponse500 | downloadAdminProblemReportAttachmentResponse503) & {
  headers: Headers;
};

export type downloadAdminProblemReportAttachmentResponse = (downloadAdminProblemReportAttachmentResponseSuccess | downloadAdminProblemReportAttachmentResponseError)

export const getDownloadAdminProblemReportAttachmentUrl = (id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/problem-reports/${id}/attachments/${fileId}/download?${stringifiedParams}` : `/api/v1/admin/problem-reports/${id}/attachments/${fileId}/download`
}

/**
 * @summary Download Attachment
 */
export const downloadAdminProblemReportAttachment = async (id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: RequestInit): Promise<downloadAdminProblemReportAttachmentResponse> => {

  return orvalClient<downloadAdminProblemReportAttachmentResponse>(getDownloadAdminProblemReportAttachmentUrl(id,fileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadAdminProblemReportAttachmentQueryKey = (id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams,) => {
    return [
    `/api/v1/admin/problem-reports/${id}/attachments/${fileId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadAdminProblemReportAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = DownloadAdminProblemReportAttachment401 | DownloadAdminProblemReportAttachment403 | DownloadAdminProblemReportAttachment404 | DownloadAdminProblemReportAttachment405 | DownloadAdminProblemReportAttachment409 | DownloadAdminProblemReportAttachment413 | DownloadAdminProblemReportAttachment422 | DownloadAdminProblemReportAttachment429 | DownloadAdminProblemReportAttachment500 | DownloadAdminProblemReportAttachment503>(id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadAdminProblemReportAttachmentQueryKey(id,fileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>> = ({ signal }) => downloadAdminProblemReportAttachment(id,fileId,params, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadAdminProblemReportAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>>
export type DownloadAdminProblemReportAttachmentQueryError = DownloadAdminProblemReportAttachment401 | DownloadAdminProblemReportAttachment403 | DownloadAdminProblemReportAttachment404 | DownloadAdminProblemReportAttachment405 | DownloadAdminProblemReportAttachment409 | DownloadAdminProblemReportAttachment413 | DownloadAdminProblemReportAttachment422 | DownloadAdminProblemReportAttachment429 | DownloadAdminProblemReportAttachment500 | DownloadAdminProblemReportAttachment503


export function useDownloadAdminProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = DownloadAdminProblemReportAttachment401 | DownloadAdminProblemReportAttachment403 | DownloadAdminProblemReportAttachment404 | DownloadAdminProblemReportAttachment405 | DownloadAdminProblemReportAttachment409 | DownloadAdminProblemReportAttachment413 | DownloadAdminProblemReportAttachment422 | DownloadAdminProblemReportAttachment429 | DownloadAdminProblemReportAttachment500 | DownloadAdminProblemReportAttachment503>(
 id: string,
    fileId: string,
    params: undefined |  DownloadAdminProblemReportAttachmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadAdminProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = DownloadAdminProblemReportAttachment401 | DownloadAdminProblemReportAttachment403 | DownloadAdminProblemReportAttachment404 | DownloadAdminProblemReportAttachment405 | DownloadAdminProblemReportAttachment409 | DownloadAdminProblemReportAttachment413 | DownloadAdminProblemReportAttachment422 | DownloadAdminProblemReportAttachment429 | DownloadAdminProblemReportAttachment500 | DownloadAdminProblemReportAttachment503>(
 id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadAdminProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = DownloadAdminProblemReportAttachment401 | DownloadAdminProblemReportAttachment403 | DownloadAdminProblemReportAttachment404 | DownloadAdminProblemReportAttachment405 | DownloadAdminProblemReportAttachment409 | DownloadAdminProblemReportAttachment413 | DownloadAdminProblemReportAttachment422 | DownloadAdminProblemReportAttachment429 | DownloadAdminProblemReportAttachment500 | DownloadAdminProblemReportAttachment503>(
 id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Attachment
 */

export function useDownloadAdminProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError = DownloadAdminProblemReportAttachment401 | DownloadAdminProblemReportAttachment403 | DownloadAdminProblemReportAttachment404 | DownloadAdminProblemReportAttachment405 | DownloadAdminProblemReportAttachment409 | DownloadAdminProblemReportAttachment413 | DownloadAdminProblemReportAttachment422 | DownloadAdminProblemReportAttachment429 | DownloadAdminProblemReportAttachment500 | DownloadAdminProblemReportAttachment503>(
 id: string,
    fileId: string,
    params?: DownloadAdminProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadAdminProblemReportAttachment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadAdminProblemReportAttachmentQueryOptions(id,fileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type commandAdminProblemReportResponse200 = {
  data: ProblemReportCommandReceipt
  status: 200
}

export type commandAdminProblemReportResponse401 = {
  data: CommandAdminProblemReport401
  status: 401
}

export type commandAdminProblemReportResponse403 = {
  data: CommandAdminProblemReport403
  status: 403
}

export type commandAdminProblemReportResponse404 = {
  data: CommandAdminProblemReport404
  status: 404
}

export type commandAdminProblemReportResponse405 = {
  data: CommandAdminProblemReport405
  status: 405
}

export type commandAdminProblemReportResponse409 = {
  data: CommandAdminProblemReport409
  status: 409
}

export type commandAdminProblemReportResponse413 = {
  data: CommandAdminProblemReport413
  status: 413
}

export type commandAdminProblemReportResponse422 = {
  data: CommandAdminProblemReport422
  status: 422
}

export type commandAdminProblemReportResponse429 = {
  data: CommandAdminProblemReport429
  status: 429
}

export type commandAdminProblemReportResponse500 = {
  data: CommandAdminProblemReport500
  status: 500
}

export type commandAdminProblemReportResponse503 = {
  data: CommandAdminProblemReport503
  status: 503
}

export type commandAdminProblemReportResponseSuccess = (commandAdminProblemReportResponse200) & {
  headers: Headers;
};
export type commandAdminProblemReportResponseError = (commandAdminProblemReportResponse401 | commandAdminProblemReportResponse403 | commandAdminProblemReportResponse404 | commandAdminProblemReportResponse405 | commandAdminProblemReportResponse409 | commandAdminProblemReportResponse413 | commandAdminProblemReportResponse422 | commandAdminProblemReportResponse429 | commandAdminProblemReportResponse500 | commandAdminProblemReportResponse503) & {
  headers: Headers;
};

export type commandAdminProblemReportResponse = (commandAdminProblemReportResponseSuccess | commandAdminProblemReportResponseError)

export const getCommandAdminProblemReportUrl = (id: string,) => {




  return `/api/v1/admin/problem-reports/${id}/commands`
}

/**
 * @summary Command
 */
export const commandAdminProblemReport = async (id: string,
    problemReportCommand: ProblemReportCommand, options?: RequestInit): Promise<commandAdminProblemReportResponse> => {

  return orvalClient<commandAdminProblemReportResponse>(getCommandAdminProblemReportUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportCommand)
  }
);}




export const getCommandAdminProblemReportMutationOptions = <TError = CommandAdminProblemReport401 | CommandAdminProblemReport403 | CommandAdminProblemReport404 | CommandAdminProblemReport405 | CommandAdminProblemReport409 | CommandAdminProblemReport413 | CommandAdminProblemReport422 | CommandAdminProblemReport429 | CommandAdminProblemReport500 | CommandAdminProblemReport503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commandAdminProblemReport>>, TError,{id: string;data: ProblemReportCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof commandAdminProblemReport>>, TError,{id: string;data: ProblemReportCommand}, TContext> => {

const mutationKey = ['commandAdminProblemReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof commandAdminProblemReport>>, {id: string;data: ProblemReportCommand}> = (props) => {
          const {id,data} = props ?? {};

          return  commandAdminProblemReport(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CommandAdminProblemReportMutationResult = NonNullable<Awaited<ReturnType<typeof commandAdminProblemReport>>>
    export type CommandAdminProblemReportMutationBody = ProblemReportCommand
    export type CommandAdminProblemReportMutationError = CommandAdminProblemReport401 | CommandAdminProblemReport403 | CommandAdminProblemReport404 | CommandAdminProblemReport405 | CommandAdminProblemReport409 | CommandAdminProblemReport413 | CommandAdminProblemReport422 | CommandAdminProblemReport429 | CommandAdminProblemReport500 | CommandAdminProblemReport503

    /**
 * @summary Command
 */
export const useCommandAdminProblemReport = <TError = CommandAdminProblemReport401 | CommandAdminProblemReport403 | CommandAdminProblemReport404 | CommandAdminProblemReport405 | CommandAdminProblemReport409 | CommandAdminProblemReport413 | CommandAdminProblemReport422 | CommandAdminProblemReport429 | CommandAdminProblemReport500 | CommandAdminProblemReport503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof commandAdminProblemReport>>, TError,{id: string;data: ProblemReportCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof commandAdminProblemReport>>,
        TError,
        {id: string;data: ProblemReportCommand},
        TContext
      > => {
      return useMutation(getCommandAdminProblemReportMutationOptions(options), queryClient);
    }
    export type listOwnProblemReportsResponse200 = {
  data: ProblemReportPage
  status: 200
}

export type listOwnProblemReportsResponse401 = {
  data: ListOwnProblemReports401
  status: 401
}

export type listOwnProblemReportsResponse403 = {
  data: ListOwnProblemReports403
  status: 403
}

export type listOwnProblemReportsResponse404 = {
  data: ListOwnProblemReports404
  status: 404
}

export type listOwnProblemReportsResponse405 = {
  data: ListOwnProblemReports405
  status: 405
}

export type listOwnProblemReportsResponse409 = {
  data: ListOwnProblemReports409
  status: 409
}

export type listOwnProblemReportsResponse413 = {
  data: ListOwnProblemReports413
  status: 413
}

export type listOwnProblemReportsResponse422 = {
  data: ListOwnProblemReports422
  status: 422
}

export type listOwnProblemReportsResponse429 = {
  data: ListOwnProblemReports429
  status: 429
}

export type listOwnProblemReportsResponse500 = {
  data: ListOwnProblemReports500
  status: 500
}

export type listOwnProblemReportsResponse503 = {
  data: ListOwnProblemReports503
  status: 503
}

export type listOwnProblemReportsResponseSuccess = (listOwnProblemReportsResponse200) & {
  headers: Headers;
};
export type listOwnProblemReportsResponseError = (listOwnProblemReportsResponse401 | listOwnProblemReportsResponse403 | listOwnProblemReportsResponse404 | listOwnProblemReportsResponse405 | listOwnProblemReportsResponse409 | listOwnProblemReportsResponse413 | listOwnProblemReportsResponse422 | listOwnProblemReportsResponse429 | listOwnProblemReportsResponse500 | listOwnProblemReportsResponse503) & {
  headers: Headers;
};

export type listOwnProblemReportsResponse = (listOwnProblemReportsResponseSuccess | listOwnProblemReportsResponseError)

export const getListOwnProblemReportsUrl = (params?: ListOwnProblemReportsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/problem-reports?${stringifiedParams}` : `/api/v1/problem-reports`
}

/**
 * @summary List Own
 */
export const listOwnProblemReports = async (params?: ListOwnProblemReportsParams, options?: RequestInit): Promise<listOwnProblemReportsResponse> => {

  return orvalClient<listOwnProblemReportsResponse>(getListOwnProblemReportsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOwnProblemReportsQueryKey = (params?: ListOwnProblemReportsParams,) => {
    return [
    `/api/v1/problem-reports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOwnProblemReportsQueryOptions = <TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = ListOwnProblemReports401 | ListOwnProblemReports403 | ListOwnProblemReports404 | ListOwnProblemReports405 | ListOwnProblemReports409 | ListOwnProblemReports413 | ListOwnProblemReports422 | ListOwnProblemReports429 | ListOwnProblemReports500 | ListOwnProblemReports503>(params?: ListOwnProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOwnProblemReportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOwnProblemReports>>> = ({ signal }) => listOwnProblemReports(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOwnProblemReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listOwnProblemReports>>>
export type ListOwnProblemReportsQueryError = ListOwnProblemReports401 | ListOwnProblemReports403 | ListOwnProblemReports404 | ListOwnProblemReports405 | ListOwnProblemReports409 | ListOwnProblemReports413 | ListOwnProblemReports422 | ListOwnProblemReports429 | ListOwnProblemReports500 | ListOwnProblemReports503


export function useListOwnProblemReports<TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = ListOwnProblemReports401 | ListOwnProblemReports403 | ListOwnProblemReports404 | ListOwnProblemReports405 | ListOwnProblemReports409 | ListOwnProblemReports413 | ListOwnProblemReports422 | ListOwnProblemReports429 | ListOwnProblemReports500 | ListOwnProblemReports503>(
 params: undefined |  ListOwnProblemReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnProblemReports>>,
          TError,
          Awaited<ReturnType<typeof listOwnProblemReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnProblemReports<TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = ListOwnProblemReports401 | ListOwnProblemReports403 | ListOwnProblemReports404 | ListOwnProblemReports405 | ListOwnProblemReports409 | ListOwnProblemReports413 | ListOwnProblemReports422 | ListOwnProblemReports429 | ListOwnProblemReports500 | ListOwnProblemReports503>(
 params?: ListOwnProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOwnProblemReports>>,
          TError,
          Awaited<ReturnType<typeof listOwnProblemReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOwnProblemReports<TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = ListOwnProblemReports401 | ListOwnProblemReports403 | ListOwnProblemReports404 | ListOwnProblemReports405 | ListOwnProblemReports409 | ListOwnProblemReports413 | ListOwnProblemReports422 | ListOwnProblemReports429 | ListOwnProblemReports500 | ListOwnProblemReports503>(
 params?: ListOwnProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Own
 */

export function useListOwnProblemReports<TData = Awaited<ReturnType<typeof listOwnProblemReports>>, TError = ListOwnProblemReports401 | ListOwnProblemReports403 | ListOwnProblemReports404 | ListOwnProblemReports405 | ListOwnProblemReports409 | ListOwnProblemReports413 | ListOwnProblemReports422 | ListOwnProblemReports429 | ListOwnProblemReports500 | ListOwnProblemReports503>(
 params?: ListOwnProblemReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOwnProblemReports>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOwnProblemReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type createProblemReportResponse200 = {
  data: ProblemReportRead
  status: 200
}

export type createProblemReportResponse201 = {
  data: ProblemReportRead
  status: 201
}

export type createProblemReportResponse401 = {
  data: CreateProblemReport401
  status: 401
}

export type createProblemReportResponse403 = {
  data: CreateProblemReport403
  status: 403
}

export type createProblemReportResponse404 = {
  data: CreateProblemReport404
  status: 404
}

export type createProblemReportResponse405 = {
  data: CreateProblemReport405
  status: 405
}

export type createProblemReportResponse409 = {
  data: CreateProblemReport409
  status: 409
}

export type createProblemReportResponse413 = {
  data: CreateProblemReport413
  status: 413
}

export type createProblemReportResponse422 = {
  data: CreateProblemReport422
  status: 422
}

export type createProblemReportResponse429 = {
  data: CreateProblemReport429
  status: 429
}

export type createProblemReportResponse500 = {
  data: CreateProblemReport500
  status: 500
}

export type createProblemReportResponse503 = {
  data: CreateProblemReport503
  status: 503
}

export type createProblemReportResponseSuccess = (createProblemReportResponse200 | createProblemReportResponse201) & {
  headers: Headers;
};
export type createProblemReportResponseError = (createProblemReportResponse401 | createProblemReportResponse403 | createProblemReportResponse404 | createProblemReportResponse405 | createProblemReportResponse409 | createProblemReportResponse413 | createProblemReportResponse422 | createProblemReportResponse429 | createProblemReportResponse500 | createProblemReportResponse503) & {
  headers: Headers;
};

export type createProblemReportResponse = (createProblemReportResponseSuccess | createProblemReportResponseError)

export const getCreateProblemReportUrl = () => {




  return `/api/v1/problem-reports`
}

/**
 * @summary Create
 */
export const createProblemReport = async (problemReportCreate: ProblemReportCreate, options?: RequestInit): Promise<createProblemReportResponse> => {

  return orvalClient<createProblemReportResponse>(getCreateProblemReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportCreate)
  }
);}




export const getCreateProblemReportMutationOptions = <TError = CreateProblemReport401 | CreateProblemReport403 | CreateProblemReport404 | CreateProblemReport405 | CreateProblemReport409 | CreateProblemReport413 | CreateProblemReport422 | CreateProblemReport429 | CreateProblemReport500 | CreateProblemReport503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProblemReport>>, TError,{data: ProblemReportCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProblemReport>>, TError,{data: ProblemReportCreate}, TContext> => {

const mutationKey = ['createProblemReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProblemReport>>, {data: ProblemReportCreate}> = (props) => {
          const {data} = props ?? {};

          return  createProblemReport(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProblemReportMutationResult = NonNullable<Awaited<ReturnType<typeof createProblemReport>>>
    export type CreateProblemReportMutationBody = ProblemReportCreate
    export type CreateProblemReportMutationError = CreateProblemReport401 | CreateProblemReport403 | CreateProblemReport404 | CreateProblemReport405 | CreateProblemReport409 | CreateProblemReport413 | CreateProblemReport422 | CreateProblemReport429 | CreateProblemReport500 | CreateProblemReport503

    /**
 * @summary Create
 */
export const useCreateProblemReport = <TError = CreateProblemReport401 | CreateProblemReport403 | CreateProblemReport404 | CreateProblemReport405 | CreateProblemReport409 | CreateProblemReport413 | CreateProblemReport422 | CreateProblemReport429 | CreateProblemReport500 | CreateProblemReport503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProblemReport>>, TError,{data: ProblemReportCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProblemReport>>,
        TError,
        {data: ProblemReportCreate},
        TContext
      > => {
      return useMutation(getCreateProblemReportMutationOptions(options), queryClient);
    }
    export type getProblemReportCapabilitiesResponse200 = {
  data: ProblemReportCapabilities
  status: 200
}

export type getProblemReportCapabilitiesResponse401 = {
  data: GetProblemReportCapabilities401
  status: 401
}

export type getProblemReportCapabilitiesResponse403 = {
  data: GetProblemReportCapabilities403
  status: 403
}

export type getProblemReportCapabilitiesResponse404 = {
  data: GetProblemReportCapabilities404
  status: 404
}

export type getProblemReportCapabilitiesResponse405 = {
  data: GetProblemReportCapabilities405
  status: 405
}

export type getProblemReportCapabilitiesResponse409 = {
  data: GetProblemReportCapabilities409
  status: 409
}

export type getProblemReportCapabilitiesResponse413 = {
  data: GetProblemReportCapabilities413
  status: 413
}

export type getProblemReportCapabilitiesResponse422 = {
  data: GetProblemReportCapabilities422
  status: 422
}

export type getProblemReportCapabilitiesResponse429 = {
  data: GetProblemReportCapabilities429
  status: 429
}

export type getProblemReportCapabilitiesResponse500 = {
  data: GetProblemReportCapabilities500
  status: 500
}

export type getProblemReportCapabilitiesResponse503 = {
  data: GetProblemReportCapabilities503
  status: 503
}

export type getProblemReportCapabilitiesResponseSuccess = (getProblemReportCapabilitiesResponse200) & {
  headers: Headers;
};
export type getProblemReportCapabilitiesResponseError = (getProblemReportCapabilitiesResponse401 | getProblemReportCapabilitiesResponse403 | getProblemReportCapabilitiesResponse404 | getProblemReportCapabilitiesResponse405 | getProblemReportCapabilitiesResponse409 | getProblemReportCapabilitiesResponse413 | getProblemReportCapabilitiesResponse422 | getProblemReportCapabilitiesResponse429 | getProblemReportCapabilitiesResponse500 | getProblemReportCapabilitiesResponse503) & {
  headers: Headers;
};

export type getProblemReportCapabilitiesResponse = (getProblemReportCapabilitiesResponseSuccess | getProblemReportCapabilitiesResponseError)

export const getGetProblemReportCapabilitiesUrl = () => {




  return `/api/v1/problem-reports/capabilities`
}

/**
 * @summary Get Capabilities
 */
export const getProblemReportCapabilities = async ( options?: RequestInit): Promise<getProblemReportCapabilitiesResponse> => {

  return orvalClient<getProblemReportCapabilitiesResponse>(getGetProblemReportCapabilitiesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProblemReportCapabilitiesQueryKey = () => {
    return [
    `/api/v1/problem-reports/capabilities`
    ] as const;
    }


export const getGetProblemReportCapabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = GetProblemReportCapabilities401 | GetProblemReportCapabilities403 | GetProblemReportCapabilities404 | GetProblemReportCapabilities405 | GetProblemReportCapabilities409 | GetProblemReportCapabilities413 | GetProblemReportCapabilities422 | GetProblemReportCapabilities429 | GetProblemReportCapabilities500 | GetProblemReportCapabilities503>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProblemReportCapabilitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProblemReportCapabilities>>> = ({ signal }) => getProblemReportCapabilities({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProblemReportCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getProblemReportCapabilities>>>
export type GetProblemReportCapabilitiesQueryError = GetProblemReportCapabilities401 | GetProblemReportCapabilities403 | GetProblemReportCapabilities404 | GetProblemReportCapabilities405 | GetProblemReportCapabilities409 | GetProblemReportCapabilities413 | GetProblemReportCapabilities422 | GetProblemReportCapabilities429 | GetProblemReportCapabilities500 | GetProblemReportCapabilities503


export function useGetProblemReportCapabilities<TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = GetProblemReportCapabilities401 | GetProblemReportCapabilities403 | GetProblemReportCapabilities404 | GetProblemReportCapabilities405 | GetProblemReportCapabilities409 | GetProblemReportCapabilities413 | GetProblemReportCapabilities422 | GetProblemReportCapabilities429 | GetProblemReportCapabilities500 | GetProblemReportCapabilities503>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProblemReportCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getProblemReportCapabilities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProblemReportCapabilities<TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = GetProblemReportCapabilities401 | GetProblemReportCapabilities403 | GetProblemReportCapabilities404 | GetProblemReportCapabilities405 | GetProblemReportCapabilities409 | GetProblemReportCapabilities413 | GetProblemReportCapabilities422 | GetProblemReportCapabilities429 | GetProblemReportCapabilities500 | GetProblemReportCapabilities503>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProblemReportCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getProblemReportCapabilities>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProblemReportCapabilities<TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = GetProblemReportCapabilities401 | GetProblemReportCapabilities403 | GetProblemReportCapabilities404 | GetProblemReportCapabilities405 | GetProblemReportCapabilities409 | GetProblemReportCapabilities413 | GetProblemReportCapabilities422 | GetProblemReportCapabilities429 | GetProblemReportCapabilities500 | GetProblemReportCapabilities503>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Capabilities
 */

export function useGetProblemReportCapabilities<TData = Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError = GetProblemReportCapabilities401 | GetProblemReportCapabilities403 | GetProblemReportCapabilities404 | GetProblemReportCapabilities405 | GetProblemReportCapabilities409 | GetProblemReportCapabilities413 | GetProblemReportCapabilities422 | GetProblemReportCapabilities429 | GetProblemReportCapabilities500 | GetProblemReportCapabilities503>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProblemReportCapabilities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProblemReportCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listProblemReportNotificationsResponse200 = {
  data: ProblemReportNotificationPage
  status: 200
}

export type listProblemReportNotificationsResponse401 = {
  data: ListProblemReportNotifications401
  status: 401
}

export type listProblemReportNotificationsResponse403 = {
  data: ListProblemReportNotifications403
  status: 403
}

export type listProblemReportNotificationsResponse404 = {
  data: ListProblemReportNotifications404
  status: 404
}

export type listProblemReportNotificationsResponse405 = {
  data: ListProblemReportNotifications405
  status: 405
}

export type listProblemReportNotificationsResponse409 = {
  data: ListProblemReportNotifications409
  status: 409
}

export type listProblemReportNotificationsResponse413 = {
  data: ListProblemReportNotifications413
  status: 413
}

export type listProblemReportNotificationsResponse422 = {
  data: ListProblemReportNotifications422
  status: 422
}

export type listProblemReportNotificationsResponse429 = {
  data: ListProblemReportNotifications429
  status: 429
}

export type listProblemReportNotificationsResponse500 = {
  data: ListProblemReportNotifications500
  status: 500
}

export type listProblemReportNotificationsResponse503 = {
  data: ListProblemReportNotifications503
  status: 503
}

export type listProblemReportNotificationsResponseSuccess = (listProblemReportNotificationsResponse200) & {
  headers: Headers;
};
export type listProblemReportNotificationsResponseError = (listProblemReportNotificationsResponse401 | listProblemReportNotificationsResponse403 | listProblemReportNotificationsResponse404 | listProblemReportNotificationsResponse405 | listProblemReportNotificationsResponse409 | listProblemReportNotificationsResponse413 | listProblemReportNotificationsResponse422 | listProblemReportNotificationsResponse429 | listProblemReportNotificationsResponse500 | listProblemReportNotificationsResponse503) & {
  headers: Headers;
};

export type listProblemReportNotificationsResponse = (listProblemReportNotificationsResponseSuccess | listProblemReportNotificationsResponseError)

export const getListProblemReportNotificationsUrl = (params?: ListProblemReportNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/problem-reports/notifications?${stringifiedParams}` : `/api/v1/problem-reports/notifications`
}

/**
 * @summary Notifications
 */
export const listProblemReportNotifications = async (params?: ListProblemReportNotificationsParams, options?: RequestInit): Promise<listProblemReportNotificationsResponse> => {

  return orvalClient<listProblemReportNotificationsResponse>(getListProblemReportNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProblemReportNotificationsQueryKey = (params?: ListProblemReportNotificationsParams,) => {
    return [
    `/api/v1/problem-reports/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProblemReportNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = ListProblemReportNotifications401 | ListProblemReportNotifications403 | ListProblemReportNotifications404 | ListProblemReportNotifications405 | ListProblemReportNotifications409 | ListProblemReportNotifications413 | ListProblemReportNotifications422 | ListProblemReportNotifications429 | ListProblemReportNotifications500 | ListProblemReportNotifications503>(params?: ListProblemReportNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProblemReportNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProblemReportNotifications>>> = ({ signal }) => listProblemReportNotifications(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProblemReportNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listProblemReportNotifications>>>
export type ListProblemReportNotificationsQueryError = ListProblemReportNotifications401 | ListProblemReportNotifications403 | ListProblemReportNotifications404 | ListProblemReportNotifications405 | ListProblemReportNotifications409 | ListProblemReportNotifications413 | ListProblemReportNotifications422 | ListProblemReportNotifications429 | ListProblemReportNotifications500 | ListProblemReportNotifications503


export function useListProblemReportNotifications<TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = ListProblemReportNotifications401 | ListProblemReportNotifications403 | ListProblemReportNotifications404 | ListProblemReportNotifications405 | ListProblemReportNotifications409 | ListProblemReportNotifications413 | ListProblemReportNotifications422 | ListProblemReportNotifications429 | ListProblemReportNotifications500 | ListProblemReportNotifications503>(
 params: undefined |  ListProblemReportNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProblemReportNotifications>>,
          TError,
          Awaited<ReturnType<typeof listProblemReportNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProblemReportNotifications<TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = ListProblemReportNotifications401 | ListProblemReportNotifications403 | ListProblemReportNotifications404 | ListProblemReportNotifications405 | ListProblemReportNotifications409 | ListProblemReportNotifications413 | ListProblemReportNotifications422 | ListProblemReportNotifications429 | ListProblemReportNotifications500 | ListProblemReportNotifications503>(
 params?: ListProblemReportNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProblemReportNotifications>>,
          TError,
          Awaited<ReturnType<typeof listProblemReportNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProblemReportNotifications<TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = ListProblemReportNotifications401 | ListProblemReportNotifications403 | ListProblemReportNotifications404 | ListProblemReportNotifications405 | ListProblemReportNotifications409 | ListProblemReportNotifications413 | ListProblemReportNotifications422 | ListProblemReportNotifications429 | ListProblemReportNotifications500 | ListProblemReportNotifications503>(
 params?: ListProblemReportNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Notifications
 */

export function useListProblemReportNotifications<TData = Awaited<ReturnType<typeof listProblemReportNotifications>>, TError = ListProblemReportNotifications401 | ListProblemReportNotifications403 | ListProblemReportNotifications404 | ListProblemReportNotifications405 | ListProblemReportNotifications409 | ListProblemReportNotifications413 | ListProblemReportNotifications422 | ListProblemReportNotifications429 | ListProblemReportNotifications500 | ListProblemReportNotifications503>(
 params?: ListProblemReportNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProblemReportNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProblemReportNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getOwnProblemReportNotificationTargetResponse200 = {
  data: ProblemReportNotificationTarget
  status: 200
}

export type getOwnProblemReportNotificationTargetResponse401 = {
  data: GetOwnProblemReportNotificationTarget401
  status: 401
}

export type getOwnProblemReportNotificationTargetResponse403 = {
  data: GetOwnProblemReportNotificationTarget403
  status: 403
}

export type getOwnProblemReportNotificationTargetResponse404 = {
  data: GetOwnProblemReportNotificationTarget404
  status: 404
}

export type getOwnProblemReportNotificationTargetResponse405 = {
  data: GetOwnProblemReportNotificationTarget405
  status: 405
}

export type getOwnProblemReportNotificationTargetResponse409 = {
  data: GetOwnProblemReportNotificationTarget409
  status: 409
}

export type getOwnProblemReportNotificationTargetResponse413 = {
  data: GetOwnProblemReportNotificationTarget413
  status: 413
}

export type getOwnProblemReportNotificationTargetResponse422 = {
  data: GetOwnProblemReportNotificationTarget422
  status: 422
}

export type getOwnProblemReportNotificationTargetResponse429 = {
  data: GetOwnProblemReportNotificationTarget429
  status: 429
}

export type getOwnProblemReportNotificationTargetResponse500 = {
  data: GetOwnProblemReportNotificationTarget500
  status: 500
}

export type getOwnProblemReportNotificationTargetResponse503 = {
  data: GetOwnProblemReportNotificationTarget503
  status: 503
}

export type getOwnProblemReportNotificationTargetResponseSuccess = (getOwnProblemReportNotificationTargetResponse200) & {
  headers: Headers;
};
export type getOwnProblemReportNotificationTargetResponseError = (getOwnProblemReportNotificationTargetResponse401 | getOwnProblemReportNotificationTargetResponse403 | getOwnProblemReportNotificationTargetResponse404 | getOwnProblemReportNotificationTargetResponse405 | getOwnProblemReportNotificationTargetResponse409 | getOwnProblemReportNotificationTargetResponse413 | getOwnProblemReportNotificationTargetResponse422 | getOwnProblemReportNotificationTargetResponse429 | getOwnProblemReportNotificationTargetResponse500 | getOwnProblemReportNotificationTargetResponse503) & {
  headers: Headers;
};

export type getOwnProblemReportNotificationTargetResponse = (getOwnProblemReportNotificationTargetResponseSuccess | getOwnProblemReportNotificationTargetResponseError)

export const getGetOwnProblemReportNotificationTargetUrl = (notificationId: string,) => {




  return `/api/v1/problem-reports/notifications/${notificationId}/target`
}

/**
 * @summary Notification Target
 */
export const getOwnProblemReportNotificationTarget = async (notificationId: string, options?: RequestInit): Promise<getOwnProblemReportNotificationTargetResponse> => {

  return orvalClient<getOwnProblemReportNotificationTargetResponse>(getGetOwnProblemReportNotificationTargetUrl(notificationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnProblemReportNotificationTargetQueryKey = (notificationId: string,) => {
    return [
    `/api/v1/problem-reports/notifications/${notificationId}/target`
    ] as const;
    }


export const getGetOwnProblemReportNotificationTargetQueryOptions = <TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = GetOwnProblemReportNotificationTarget401 | GetOwnProblemReportNotificationTarget403 | GetOwnProblemReportNotificationTarget404 | GetOwnProblemReportNotificationTarget405 | GetOwnProblemReportNotificationTarget409 | GetOwnProblemReportNotificationTarget413 | GetOwnProblemReportNotificationTarget422 | GetOwnProblemReportNotificationTarget429 | GetOwnProblemReportNotificationTarget500 | GetOwnProblemReportNotificationTarget503>(notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnProblemReportNotificationTargetQueryKey(notificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>> = ({ signal }) => getOwnProblemReportNotificationTarget(notificationId, { signal });





   return  { queryKey, queryFn, enabled: notificationId !== null && notificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnProblemReportNotificationTargetQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>>
export type GetOwnProblemReportNotificationTargetQueryError = GetOwnProblemReportNotificationTarget401 | GetOwnProblemReportNotificationTarget403 | GetOwnProblemReportNotificationTarget404 | GetOwnProblemReportNotificationTarget405 | GetOwnProblemReportNotificationTarget409 | GetOwnProblemReportNotificationTarget413 | GetOwnProblemReportNotificationTarget422 | GetOwnProblemReportNotificationTarget429 | GetOwnProblemReportNotificationTarget500 | GetOwnProblemReportNotificationTarget503


export function useGetOwnProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = GetOwnProblemReportNotificationTarget401 | GetOwnProblemReportNotificationTarget403 | GetOwnProblemReportNotificationTarget404 | GetOwnProblemReportNotificationTarget405 | GetOwnProblemReportNotificationTarget409 | GetOwnProblemReportNotificationTarget413 | GetOwnProblemReportNotificationTarget422 | GetOwnProblemReportNotificationTarget429 | GetOwnProblemReportNotificationTarget500 | GetOwnProblemReportNotificationTarget503>(
 notificationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>,
          TError,
          Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = GetOwnProblemReportNotificationTarget401 | GetOwnProblemReportNotificationTarget403 | GetOwnProblemReportNotificationTarget404 | GetOwnProblemReportNotificationTarget405 | GetOwnProblemReportNotificationTarget409 | GetOwnProblemReportNotificationTarget413 | GetOwnProblemReportNotificationTarget422 | GetOwnProblemReportNotificationTarget429 | GetOwnProblemReportNotificationTarget500 | GetOwnProblemReportNotificationTarget503>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>,
          TError,
          Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = GetOwnProblemReportNotificationTarget401 | GetOwnProblemReportNotificationTarget403 | GetOwnProblemReportNotificationTarget404 | GetOwnProblemReportNotificationTarget405 | GetOwnProblemReportNotificationTarget409 | GetOwnProblemReportNotificationTarget413 | GetOwnProblemReportNotificationTarget422 | GetOwnProblemReportNotificationTarget429 | GetOwnProblemReportNotificationTarget500 | GetOwnProblemReportNotificationTarget503>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Notification Target
 */

export function useGetOwnProblemReportNotificationTarget<TData = Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError = GetOwnProblemReportNotificationTarget401 | GetOwnProblemReportNotificationTarget403 | GetOwnProblemReportNotificationTarget404 | GetOwnProblemReportNotificationTarget405 | GetOwnProblemReportNotificationTarget409 | GetOwnProblemReportNotificationTarget413 | GetOwnProblemReportNotificationTarget422 | GetOwnProblemReportNotificationTarget429 | GetOwnProblemReportNotificationTarget500 | GetOwnProblemReportNotificationTarget503>(
 notificationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReportNotificationTarget>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnProblemReportNotificationTargetQueryOptions(notificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getOwnProblemReportResponse200 = {
  data: ProblemReportRead
  status: 200
}

export type getOwnProblemReportResponse401 = {
  data: GetOwnProblemReport401
  status: 401
}

export type getOwnProblemReportResponse403 = {
  data: GetOwnProblemReport403
  status: 403
}

export type getOwnProblemReportResponse404 = {
  data: GetOwnProblemReport404
  status: 404
}

export type getOwnProblemReportResponse405 = {
  data: GetOwnProblemReport405
  status: 405
}

export type getOwnProblemReportResponse409 = {
  data: GetOwnProblemReport409
  status: 409
}

export type getOwnProblemReportResponse413 = {
  data: GetOwnProblemReport413
  status: 413
}

export type getOwnProblemReportResponse422 = {
  data: GetOwnProblemReport422
  status: 422
}

export type getOwnProblemReportResponse429 = {
  data: GetOwnProblemReport429
  status: 429
}

export type getOwnProblemReportResponse500 = {
  data: GetOwnProblemReport500
  status: 500
}

export type getOwnProblemReportResponse503 = {
  data: GetOwnProblemReport503
  status: 503
}

export type getOwnProblemReportResponseSuccess = (getOwnProblemReportResponse200) & {
  headers: Headers;
};
export type getOwnProblemReportResponseError = (getOwnProblemReportResponse401 | getOwnProblemReportResponse403 | getOwnProblemReportResponse404 | getOwnProblemReportResponse405 | getOwnProblemReportResponse409 | getOwnProblemReportResponse413 | getOwnProblemReportResponse422 | getOwnProblemReportResponse429 | getOwnProblemReportResponse500 | getOwnProblemReportResponse503) & {
  headers: Headers;
};

export type getOwnProblemReportResponse = (getOwnProblemReportResponseSuccess | getOwnProblemReportResponseError)

export const getGetOwnProblemReportUrl = (id: string,) => {




  return `/api/v1/problem-reports/${id}`
}

/**
 * @summary Detail
 */
export const getOwnProblemReport = async (id: string, options?: RequestInit): Promise<getOwnProblemReportResponse> => {

  return orvalClient<getOwnProblemReportResponse>(getGetOwnProblemReportUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOwnProblemReportQueryKey = (id: string,) => {
    return [
    `/api/v1/problem-reports/${id}`
    ] as const;
    }


export const getGetOwnProblemReportQueryOptions = <TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = GetOwnProblemReport401 | GetOwnProblemReport403 | GetOwnProblemReport404 | GetOwnProblemReport405 | GetOwnProblemReport409 | GetOwnProblemReport413 | GetOwnProblemReport422 | GetOwnProblemReport429 | GetOwnProblemReport500 | GetOwnProblemReport503>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOwnProblemReportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOwnProblemReport>>> = ({ signal }) => getOwnProblemReport(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOwnProblemReportQueryResult = NonNullable<Awaited<ReturnType<typeof getOwnProblemReport>>>
export type GetOwnProblemReportQueryError = GetOwnProblemReport401 | GetOwnProblemReport403 | GetOwnProblemReport404 | GetOwnProblemReport405 | GetOwnProblemReport409 | GetOwnProblemReport413 | GetOwnProblemReport422 | GetOwnProblemReport429 | GetOwnProblemReport500 | GetOwnProblemReport503


export function useGetOwnProblemReport<TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = GetOwnProblemReport401 | GetOwnProblemReport403 | GetOwnProblemReport404 | GetOwnProblemReport405 | GetOwnProblemReport409 | GetOwnProblemReport413 | GetOwnProblemReport422 | GetOwnProblemReport429 | GetOwnProblemReport500 | GetOwnProblemReport503>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnProblemReport>>,
          TError,
          Awaited<ReturnType<typeof getOwnProblemReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnProblemReport<TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = GetOwnProblemReport401 | GetOwnProblemReport403 | GetOwnProblemReport404 | GetOwnProblemReport405 | GetOwnProblemReport409 | GetOwnProblemReport413 | GetOwnProblemReport422 | GetOwnProblemReport429 | GetOwnProblemReport500 | GetOwnProblemReport503>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOwnProblemReport>>,
          TError,
          Awaited<ReturnType<typeof getOwnProblemReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOwnProblemReport<TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = GetOwnProblemReport401 | GetOwnProblemReport403 | GetOwnProblemReport404 | GetOwnProblemReport405 | GetOwnProblemReport409 | GetOwnProblemReport413 | GetOwnProblemReport422 | GetOwnProblemReport429 | GetOwnProblemReport500 | GetOwnProblemReport503>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detail
 */

export function useGetOwnProblemReport<TData = Awaited<ReturnType<typeof getOwnProblemReport>>, TError = GetOwnProblemReport401 | GetOwnProblemReport403 | GetOwnProblemReport404 | GetOwnProblemReport405 | GetOwnProblemReport409 | GetOwnProblemReport413 | GetOwnProblemReport422 | GetOwnProblemReport429 | GetOwnProblemReport500 | GetOwnProblemReport503>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOwnProblemReport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOwnProblemReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type confirmProblemReportAttachmentResponse200 = {
  data: ProblemReportAttachmentRead
  status: 200
}

export type confirmProblemReportAttachmentResponse201 = {
  data: ProblemReportAttachmentRead
  status: 201
}

export type confirmProblemReportAttachmentResponse401 = {
  data: ConfirmProblemReportAttachment401
  status: 401
}

export type confirmProblemReportAttachmentResponse403 = {
  data: ConfirmProblemReportAttachment403
  status: 403
}

export type confirmProblemReportAttachmentResponse404 = {
  data: ConfirmProblemReportAttachment404
  status: 404
}

export type confirmProblemReportAttachmentResponse405 = {
  data: ConfirmProblemReportAttachment405
  status: 405
}

export type confirmProblemReportAttachmentResponse409 = {
  data: ConfirmProblemReportAttachment409
  status: 409
}

export type confirmProblemReportAttachmentResponse413 = {
  data: ConfirmProblemReportAttachment413
  status: 413
}

export type confirmProblemReportAttachmentResponse422 = {
  data: ConfirmProblemReportAttachment422
  status: 422
}

export type confirmProblemReportAttachmentResponse429 = {
  data: ConfirmProblemReportAttachment429
  status: 429
}

export type confirmProblemReportAttachmentResponse500 = {
  data: ConfirmProblemReportAttachment500
  status: 500
}

export type confirmProblemReportAttachmentResponse503 = {
  data: ConfirmProblemReportAttachment503
  status: 503
}

export type confirmProblemReportAttachmentResponseSuccess = (confirmProblemReportAttachmentResponse200 | confirmProblemReportAttachmentResponse201) & {
  headers: Headers;
};
export type confirmProblemReportAttachmentResponseError = (confirmProblemReportAttachmentResponse401 | confirmProblemReportAttachmentResponse403 | confirmProblemReportAttachmentResponse404 | confirmProblemReportAttachmentResponse405 | confirmProblemReportAttachmentResponse409 | confirmProblemReportAttachmentResponse413 | confirmProblemReportAttachmentResponse422 | confirmProblemReportAttachmentResponse429 | confirmProblemReportAttachmentResponse500 | confirmProblemReportAttachmentResponse503) & {
  headers: Headers;
};

export type confirmProblemReportAttachmentResponse = (confirmProblemReportAttachmentResponseSuccess | confirmProblemReportAttachmentResponseError)

export const getConfirmProblemReportAttachmentUrl = (id: string,) => {




  return `/api/v1/problem-reports/${id}/attachments/confirm`
}

/**
 * @summary Confirm Attachment
 */
export const confirmProblemReportAttachment = async (id: string,
    problemReportUploadConfirm: ProblemReportUploadConfirm, options?: RequestInit): Promise<confirmProblemReportAttachmentResponse> => {

  return orvalClient<confirmProblemReportAttachmentResponse>(getConfirmProblemReportAttachmentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportUploadConfirm)
  }
);}




export const getConfirmProblemReportAttachmentMutationOptions = <TError = ConfirmProblemReportAttachment401 | ConfirmProblemReportAttachment403 | ConfirmProblemReportAttachment404 | ConfirmProblemReportAttachment405 | ConfirmProblemReportAttachment409 | ConfirmProblemReportAttachment413 | ConfirmProblemReportAttachment422 | ConfirmProblemReportAttachment429 | ConfirmProblemReportAttachment500 | ConfirmProblemReportAttachment503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadConfirm}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadConfirm}, TContext> => {

const mutationKey = ['confirmProblemReportAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmProblemReportAttachment>>, {id: string;data: ProblemReportUploadConfirm}> = (props) => {
          const {id,data} = props ?? {};

          return  confirmProblemReportAttachment(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmProblemReportAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof confirmProblemReportAttachment>>>
    export type ConfirmProblemReportAttachmentMutationBody = ProblemReportUploadConfirm
    export type ConfirmProblemReportAttachmentMutationError = ConfirmProblemReportAttachment401 | ConfirmProblemReportAttachment403 | ConfirmProblemReportAttachment404 | ConfirmProblemReportAttachment405 | ConfirmProblemReportAttachment409 | ConfirmProblemReportAttachment413 | ConfirmProblemReportAttachment422 | ConfirmProblemReportAttachment429 | ConfirmProblemReportAttachment500 | ConfirmProblemReportAttachment503

    /**
 * @summary Confirm Attachment
 */
export const useConfirmProblemReportAttachment = <TError = ConfirmProblemReportAttachment401 | ConfirmProblemReportAttachment403 | ConfirmProblemReportAttachment404 | ConfirmProblemReportAttachment405 | ConfirmProblemReportAttachment409 | ConfirmProblemReportAttachment413 | ConfirmProblemReportAttachment422 | ConfirmProblemReportAttachment429 | ConfirmProblemReportAttachment500 | ConfirmProblemReportAttachment503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadConfirm}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmProblemReportAttachment>>,
        TError,
        {id: string;data: ProblemReportUploadConfirm},
        TContext
      > => {
      return useMutation(getConfirmProblemReportAttachmentMutationOptions(options), queryClient);
    }
    export type reserveProblemReportAttachmentResponse200 = {
  data: ProblemReportUploadGrant
  status: 200
}

export type reserveProblemReportAttachmentResponse201 = {
  data: ProblemReportUploadGrant
  status: 201
}

export type reserveProblemReportAttachmentResponse401 = {
  data: ReserveProblemReportAttachment401
  status: 401
}

export type reserveProblemReportAttachmentResponse403 = {
  data: ReserveProblemReportAttachment403
  status: 403
}

export type reserveProblemReportAttachmentResponse404 = {
  data: ReserveProblemReportAttachment404
  status: 404
}

export type reserveProblemReportAttachmentResponse405 = {
  data: ReserveProblemReportAttachment405
  status: 405
}

export type reserveProblemReportAttachmentResponse409 = {
  data: ReserveProblemReportAttachment409
  status: 409
}

export type reserveProblemReportAttachmentResponse413 = {
  data: ReserveProblemReportAttachment413
  status: 413
}

export type reserveProblemReportAttachmentResponse422 = {
  data: ReserveProblemReportAttachment422
  status: 422
}

export type reserveProblemReportAttachmentResponse429 = {
  data: ReserveProblemReportAttachment429
  status: 429
}

export type reserveProblemReportAttachmentResponse500 = {
  data: ReserveProblemReportAttachment500
  status: 500
}

export type reserveProblemReportAttachmentResponse503 = {
  data: ReserveProblemReportAttachment503
  status: 503
}

export type reserveProblemReportAttachmentResponseSuccess = (reserveProblemReportAttachmentResponse200 | reserveProblemReportAttachmentResponse201) & {
  headers: Headers;
};
export type reserveProblemReportAttachmentResponseError = (reserveProblemReportAttachmentResponse401 | reserveProblemReportAttachmentResponse403 | reserveProblemReportAttachmentResponse404 | reserveProblemReportAttachmentResponse405 | reserveProblemReportAttachmentResponse409 | reserveProblemReportAttachmentResponse413 | reserveProblemReportAttachmentResponse422 | reserveProblemReportAttachmentResponse429 | reserveProblemReportAttachmentResponse500 | reserveProblemReportAttachmentResponse503) & {
  headers: Headers;
};

export type reserveProblemReportAttachmentResponse = (reserveProblemReportAttachmentResponseSuccess | reserveProblemReportAttachmentResponseError)

export const getReserveProblemReportAttachmentUrl = (id: string,) => {




  return `/api/v1/problem-reports/${id}/attachments/upload`
}

/**
 * @summary Reserve Attachment
 */
export const reserveProblemReportAttachment = async (id: string,
    problemReportUploadRequest: ProblemReportUploadRequest, options?: RequestInit): Promise<reserveProblemReportAttachmentResponse> => {

  return orvalClient<reserveProblemReportAttachmentResponse>(getReserveProblemReportAttachmentUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportUploadRequest)
  }
);}




export const getReserveProblemReportAttachmentMutationOptions = <TError = ReserveProblemReportAttachment401 | ReserveProblemReportAttachment403 | ReserveProblemReportAttachment404 | ReserveProblemReportAttachment405 | ReserveProblemReportAttachment409 | ReserveProblemReportAttachment413 | ReserveProblemReportAttachment422 | ReserveProblemReportAttachment429 | ReserveProblemReportAttachment500 | ReserveProblemReportAttachment503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reserveProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reserveProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadRequest}, TContext> => {

const mutationKey = ['reserveProblemReportAttachment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reserveProblemReportAttachment>>, {id: string;data: ProblemReportUploadRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  reserveProblemReportAttachment(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReserveProblemReportAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof reserveProblemReportAttachment>>>
    export type ReserveProblemReportAttachmentMutationBody = ProblemReportUploadRequest
    export type ReserveProblemReportAttachmentMutationError = ReserveProblemReportAttachment401 | ReserveProblemReportAttachment403 | ReserveProblemReportAttachment404 | ReserveProblemReportAttachment405 | ReserveProblemReportAttachment409 | ReserveProblemReportAttachment413 | ReserveProblemReportAttachment422 | ReserveProblemReportAttachment429 | ReserveProblemReportAttachment500 | ReserveProblemReportAttachment503

    /**
 * @summary Reserve Attachment
 */
export const useReserveProblemReportAttachment = <TError = ReserveProblemReportAttachment401 | ReserveProblemReportAttachment403 | ReserveProblemReportAttachment404 | ReserveProblemReportAttachment405 | ReserveProblemReportAttachment409 | ReserveProblemReportAttachment413 | ReserveProblemReportAttachment422 | ReserveProblemReportAttachment429 | ReserveProblemReportAttachment500 | ReserveProblemReportAttachment503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reserveProblemReportAttachment>>, TError,{id: string;data: ProblemReportUploadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reserveProblemReportAttachment>>,
        TError,
        {id: string;data: ProblemReportUploadRequest},
        TContext
      > => {
      return useMutation(getReserveProblemReportAttachmentMutationOptions(options), queryClient);
    }
    export type downloadOwnProblemReportAttachmentResponse200 = {
  data: ProblemReportDownloadGrant
  status: 200
}

export type downloadOwnProblemReportAttachmentResponse401 = {
  data: DownloadOwnProblemReportAttachment401
  status: 401
}

export type downloadOwnProblemReportAttachmentResponse403 = {
  data: DownloadOwnProblemReportAttachment403
  status: 403
}

export type downloadOwnProblemReportAttachmentResponse404 = {
  data: DownloadOwnProblemReportAttachment404
  status: 404
}

export type downloadOwnProblemReportAttachmentResponse405 = {
  data: DownloadOwnProblemReportAttachment405
  status: 405
}

export type downloadOwnProblemReportAttachmentResponse409 = {
  data: DownloadOwnProblemReportAttachment409
  status: 409
}

export type downloadOwnProblemReportAttachmentResponse413 = {
  data: DownloadOwnProblemReportAttachment413
  status: 413
}

export type downloadOwnProblemReportAttachmentResponse422 = {
  data: DownloadOwnProblemReportAttachment422
  status: 422
}

export type downloadOwnProblemReportAttachmentResponse429 = {
  data: DownloadOwnProblemReportAttachment429
  status: 429
}

export type downloadOwnProblemReportAttachmentResponse500 = {
  data: DownloadOwnProblemReportAttachment500
  status: 500
}

export type downloadOwnProblemReportAttachmentResponse503 = {
  data: DownloadOwnProblemReportAttachment503
  status: 503
}

export type downloadOwnProblemReportAttachmentResponseSuccess = (downloadOwnProblemReportAttachmentResponse200) & {
  headers: Headers;
};
export type downloadOwnProblemReportAttachmentResponseError = (downloadOwnProblemReportAttachmentResponse401 | downloadOwnProblemReportAttachmentResponse403 | downloadOwnProblemReportAttachmentResponse404 | downloadOwnProblemReportAttachmentResponse405 | downloadOwnProblemReportAttachmentResponse409 | downloadOwnProblemReportAttachmentResponse413 | downloadOwnProblemReportAttachmentResponse422 | downloadOwnProblemReportAttachmentResponse429 | downloadOwnProblemReportAttachmentResponse500 | downloadOwnProblemReportAttachmentResponse503) & {
  headers: Headers;
};

export type downloadOwnProblemReportAttachmentResponse = (downloadOwnProblemReportAttachmentResponseSuccess | downloadOwnProblemReportAttachmentResponseError)

export const getDownloadOwnProblemReportAttachmentUrl = (id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/problem-reports/${id}/attachments/${fileId}/download?${stringifiedParams}` : `/api/v1/problem-reports/${id}/attachments/${fileId}/download`
}

/**
 * @summary Download Attachment
 */
export const downloadOwnProblemReportAttachment = async (id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: RequestInit): Promise<downloadOwnProblemReportAttachmentResponse> => {

  return orvalClient<downloadOwnProblemReportAttachmentResponse>(getDownloadOwnProblemReportAttachmentUrl(id,fileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadOwnProblemReportAttachmentQueryKey = (id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams,) => {
    return [
    `/api/v1/problem-reports/${id}/attachments/${fileId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getDownloadOwnProblemReportAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = DownloadOwnProblemReportAttachment401 | DownloadOwnProblemReportAttachment403 | DownloadOwnProblemReportAttachment404 | DownloadOwnProblemReportAttachment405 | DownloadOwnProblemReportAttachment409 | DownloadOwnProblemReportAttachment413 | DownloadOwnProblemReportAttachment422 | DownloadOwnProblemReportAttachment429 | DownloadOwnProblemReportAttachment500 | DownloadOwnProblemReportAttachment503>(id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadOwnProblemReportAttachmentQueryKey(id,fileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>> = ({ signal }) => downloadOwnProblemReportAttachment(id,fileId,params, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadOwnProblemReportAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>>
export type DownloadOwnProblemReportAttachmentQueryError = DownloadOwnProblemReportAttachment401 | DownloadOwnProblemReportAttachment403 | DownloadOwnProblemReportAttachment404 | DownloadOwnProblemReportAttachment405 | DownloadOwnProblemReportAttachment409 | DownloadOwnProblemReportAttachment413 | DownloadOwnProblemReportAttachment422 | DownloadOwnProblemReportAttachment429 | DownloadOwnProblemReportAttachment500 | DownloadOwnProblemReportAttachment503


export function useDownloadOwnProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = DownloadOwnProblemReportAttachment401 | DownloadOwnProblemReportAttachment403 | DownloadOwnProblemReportAttachment404 | DownloadOwnProblemReportAttachment405 | DownloadOwnProblemReportAttachment409 | DownloadOwnProblemReportAttachment413 | DownloadOwnProblemReportAttachment422 | DownloadOwnProblemReportAttachment429 | DownloadOwnProblemReportAttachment500 | DownloadOwnProblemReportAttachment503>(
 id: string,
    fileId: string,
    params: undefined |  DownloadOwnProblemReportAttachmentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadOwnProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = DownloadOwnProblemReportAttachment401 | DownloadOwnProblemReportAttachment403 | DownloadOwnProblemReportAttachment404 | DownloadOwnProblemReportAttachment405 | DownloadOwnProblemReportAttachment409 | DownloadOwnProblemReportAttachment413 | DownloadOwnProblemReportAttachment422 | DownloadOwnProblemReportAttachment429 | DownloadOwnProblemReportAttachment500 | DownloadOwnProblemReportAttachment503>(
 id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>,
          TError,
          Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadOwnProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = DownloadOwnProblemReportAttachment401 | DownloadOwnProblemReportAttachment403 | DownloadOwnProblemReportAttachment404 | DownloadOwnProblemReportAttachment405 | DownloadOwnProblemReportAttachment409 | DownloadOwnProblemReportAttachment413 | DownloadOwnProblemReportAttachment422 | DownloadOwnProblemReportAttachment429 | DownloadOwnProblemReportAttachment500 | DownloadOwnProblemReportAttachment503>(
 id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download Attachment
 */

export function useDownloadOwnProblemReportAttachment<TData = Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError = DownloadOwnProblemReportAttachment401 | DownloadOwnProblemReportAttachment403 | DownloadOwnProblemReportAttachment404 | DownloadOwnProblemReportAttachment405 | DownloadOwnProblemReportAttachment409 | DownloadOwnProblemReportAttachment413 | DownloadOwnProblemReportAttachment422 | DownloadOwnProblemReportAttachment429 | DownloadOwnProblemReportAttachment500 | DownloadOwnProblemReportAttachment503>(
 id: string,
    fileId: string,
    params?: DownloadOwnProblemReportAttachmentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadOwnProblemReportAttachment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadOwnProblemReportAttachmentQueryOptions(id,fileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type confirmProblemReportResponse200 = {
  data: ProblemReportCommandReceipt
  status: 200
}

export type confirmProblemReportResponse401 = {
  data: ConfirmProblemReport401
  status: 401
}

export type confirmProblemReportResponse403 = {
  data: ConfirmProblemReport403
  status: 403
}

export type confirmProblemReportResponse404 = {
  data: ConfirmProblemReport404
  status: 404
}

export type confirmProblemReportResponse405 = {
  data: ConfirmProblemReport405
  status: 405
}

export type confirmProblemReportResponse409 = {
  data: ConfirmProblemReport409
  status: 409
}

export type confirmProblemReportResponse413 = {
  data: ConfirmProblemReport413
  status: 413
}

export type confirmProblemReportResponse422 = {
  data: ConfirmProblemReport422
  status: 422
}

export type confirmProblemReportResponse429 = {
  data: ConfirmProblemReport429
  status: 429
}

export type confirmProblemReportResponse500 = {
  data: ConfirmProblemReport500
  status: 500
}

export type confirmProblemReportResponse503 = {
  data: ConfirmProblemReport503
  status: 503
}

export type confirmProblemReportResponseSuccess = (confirmProblemReportResponse200) & {
  headers: Headers;
};
export type confirmProblemReportResponseError = (confirmProblemReportResponse401 | confirmProblemReportResponse403 | confirmProblemReportResponse404 | confirmProblemReportResponse405 | confirmProblemReportResponse409 | confirmProblemReportResponse413 | confirmProblemReportResponse422 | confirmProblemReportResponse429 | confirmProblemReportResponse500 | confirmProblemReportResponse503) & {
  headers: Headers;
};

export type confirmProblemReportResponse = (confirmProblemReportResponseSuccess | confirmProblemReportResponseError)

export const getConfirmProblemReportUrl = (id: string,) => {




  return `/api/v1/problem-reports/${id}/confirmation`
}

/**
 * @summary Confirm
 */
export const confirmProblemReport = async (id: string,
    problemReportConfirmation: ProblemReportConfirmation, options?: RequestInit): Promise<confirmProblemReportResponse> => {

  return orvalClient<confirmProblemReportResponse>(getConfirmProblemReportUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(problemReportConfirmation)
  }
);}




export const getConfirmProblemReportMutationOptions = <TError = ConfirmProblemReport401 | ConfirmProblemReport403 | ConfirmProblemReport404 | ConfirmProblemReport405 | ConfirmProblemReport409 | ConfirmProblemReport413 | ConfirmProblemReport422 | ConfirmProblemReport429 | ConfirmProblemReport500 | ConfirmProblemReport503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReport>>, TError,{id: string;data: ProblemReportConfirmation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReport>>, TError,{id: string;data: ProblemReportConfirmation}, TContext> => {

const mutationKey = ['confirmProblemReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmProblemReport>>, {id: string;data: ProblemReportConfirmation}> = (props) => {
          const {id,data} = props ?? {};

          return  confirmProblemReport(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmProblemReportMutationResult = NonNullable<Awaited<ReturnType<typeof confirmProblemReport>>>
    export type ConfirmProblemReportMutationBody = ProblemReportConfirmation
    export type ConfirmProblemReportMutationError = ConfirmProblemReport401 | ConfirmProblemReport403 | ConfirmProblemReport404 | ConfirmProblemReport405 | ConfirmProblemReport409 | ConfirmProblemReport413 | ConfirmProblemReport422 | ConfirmProblemReport429 | ConfirmProblemReport500 | ConfirmProblemReport503

    /**
 * @summary Confirm
 */
export const useConfirmProblemReport = <TError = ConfirmProblemReport401 | ConfirmProblemReport403 | ConfirmProblemReport404 | ConfirmProblemReport405 | ConfirmProblemReport409 | ConfirmProblemReport413 | ConfirmProblemReport422 | ConfirmProblemReport429 | ConfirmProblemReport500 | ConfirmProblemReport503,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmProblemReport>>, TError,{id: string;data: ProblemReportConfirmation}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmProblemReport>>,
        TError,
        {id: string;data: ProblemReportConfirmation},
        TContext
      > => {
      return useMutation(getConfirmProblemReportMutationOptions(options), queryClient);
    }
